module.exports = __webpack_public_path__ + "img/cavaliernoir.c6600033.svg";